import { ChronoUnit, Duration } from "@js-joda/core";
import { T } from "services/lang/LanguageService";

export const TIME_UNITS = [
  {
    value: ChronoUnit.SECONDS,
    label: T("time.seconds"),
  },
  {
    value: ChronoUnit.MINUTES,
    label: T("time.minutes"),
  },
  {
    value: ChronoUnit.HOURS,
    label: T("time.hours"),
  },
  {
    value: ChronoUnit.DAYS,
    label: T("time.days"),
  },
  {
    value: ChronoUnit.WEEKS,
    label: T("time.weeks"),
  },
  {
    value: ChronoUnit.MONTHS,
    label: T("time.months"),
  },
  {
    value: ChronoUnit.YEARS,
    label: T("time.years"),
  },
];

const CHRONO_TO_DAYS = [ChronoUnit.SECONDS, ChronoUnit.MINUTES, ChronoUnit.HOURS, ChronoUnit.DAYS];

export const TIME_UNITS_TO_DAYS = TIME_UNITS.filter(unit => CHRONO_TO_DAYS.includes(unit.value));

export const durationMinUnit = (duration: Duration): ChronoUnit => {
  if (duration.toDays() > 0) {
    return ChronoUnit.DAYS;
  }
  if (duration.toHours() > 0) {
    return ChronoUnit.HOURS;
  }
  if (duration.toMinutes() > 0) {
    return ChronoUnit.MINUTES;
  }
  return ChronoUnit.SECONDS;
};

export const getValueForUnit = (duration: Duration, unit: ChronoUnit): number => {
  if (unit === ChronoUnit.DAYS) {
    return duration.toDays();
  }
  if (unit === ChronoUnit.HOURS) {
    return duration.toHours();
  }
  if (unit === ChronoUnit.MINUTES) {
    return duration.toMinutes();
  }
  return duration.seconds();
};

export type TimeOptionKeys = keyof typeof TimeOptions;

export const TimeOptions = {
  DAYS: {
    value: T("time.daily"),
    duration: Duration.ofDays(1),
    timeFormat: "MM-dd",
    name: "DAYS"
  },
  HOURS: {
    value: T("time.hourly"),
    duration: Duration.ofHours(1),
    timeFormat: "HH:mm",
    name: "HOURS"
  },
};
